import { IconButton, IconButtonProps, styled } from '@mui/material';

export const TipTapBarButton = styled(IconButton)<IconButtonProps>(() => ({
  padding: '2px',
  height: 40,
  width: 40,
  minHeight: 40,
  minWidth: 40,
}));
